export default "__VITE_ASSET__BjW5tokk__"